import React, { useState, useEffect } from "react";
import LegalPage from "../legal/LegalPage";
import { getPrivacyPolicy } from "../../services/data.service";
import Loading from "../../assets/images/icons/loading.gif";

const PrivacyPolicy = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getPrivacyPolicy();
        if (res && res.data && res.data.data) {
          setData(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching privacy policy:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <img src={Loading} alt="Loading..." style={{ width: '50px' }} />
      </div>
    );
  }

  if (!data) return <div>Failed to load privacy policy.</div>;

  return <LegalPage data={data} />;
};

export default PrivacyPolicy;
